import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {CookieService} from 'ngx-cookie';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {isPlatformBrowser} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '@services/modal/modal.service';
import {Store} from '@ngxs/store';
import {ToggleGlobalLoader} from '@store/loader';
import {AuthService} from '@services/auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private cookie: CookieService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
    private translate: TranslateService,
    private modalService: ModalService,
    private store: Store,
    private authService: AuthService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(catchError((error) => {
        this.store.dispatch(new ToggleGlobalLoader(false));
        if (error) {
          switch (error.status) {
            case 401: {
              this.Error401Handler();
              break;
            }
            case 404: {
              this.Error404Handler(error);
              break;
            }
            case 422: {
              this.Error422Handler(error);
              break;
            }
            case 504: {
              this.translate.get('app.confirm.timeOutError')
                .subscribe(msg => this.modalService.showMsg(msg));
              break;
            }
            default: {
              console.log(error);
              break;
            }
          }
        }
        return throwError(error);
      }));
  }

  Error401Handler(): void {
    const tkn = this.cookie.get('DWallUserToken');
    if (tkn) {
      this.authService.clearLocalStorageDWallData();
      this.router.navigate(['/authentication']);
    }
    console.log('401');
  }

  Error404Handler(error: HttpErrorResponse): void {
    const acceptableUrl = ['api.mapbox', 'testrss'];
    const isAcceptable = acceptableUrl.find(url => error.url?.includes(url));

    if (isPlatformBrowser(this.platformId) && !isAcceptable?.length)
      this.router.navigateByUrl('/not-found', {skipLocationChange: true});
  }

  Error422Handler(error: HttpErrorResponse): void {
    if (error?.error?.errors?.quantity[0]) this.modalService.showMsg(error?.error?.errors?.quantity[0]);
    else throwError(error);
  }
}
